<template>
  <div v-show="value" class="invite-warp" @click="onClose">
    <div class="invite-body" @click.stop="">
      <div class="invite-title">{{ i18n.title }}</div>
      <div class="invite-tips">{{ i18n.tips }}</div>
      <div class="invite-card">
        <img class="invite-card-bg" src="@/assets/imgs/coupon_bg.png" alt="">
        <div class="invite-card-body">
          <vue-qr :text="`https://m.beesmartconnect.com/#/?inviterCode=${inviterCode}`" :size="137" :margin="0" backgroundColor="#FFCA0E"></vue-qr>
          <div class="invite-card-info">
            <div>{{ i18n.coupon_code }}</div>
            <div class="invite-card-label">{{ inviterCode }}</div>
          </div>
        </div>
      </div>
      <div class="invite-text">{{ i18n.text }}</div>
    </div>
    <img class="invite-close" src="@/assets/imgs/icon_close.png" alt="">
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { INVITE_CODE } from '@/apis/user.js'

export default {
  props: {
    // 是否显示
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueQr
  },
  computed: {
    i18n() {
      return this.$t("invite")
    }
  },
  data() {
    return {
      inviterCode: ""
    }
  },
  methods: {
    onClose() {
      this.$emit('input', false)
    },
    getInvite() {
      this.$get(
        INVITE_CODE,
        {},
        (resp) => {
          this.$loading(false)
          this.inviterCode = resp.data
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  },
  created() {
    this.getInvite()
  }
}
</script>

<style lang="less" scoped>
.invite-warp {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.34);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .invite-body {
    width: 70%;
    background-color: #fff;
    color: #000;
    border-radius: 18px;
    padding: 0 40px;
    text-align: center;
    .invite-title {
      font-size: 46px;
      font-weight: bold;
      padding: 50px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .invite-tips {
      padding: 28px 40px;
      font-size: 22px;
    }
    .invite-card {
      position: relative;
      .invite-card-bg {
        width: 100%;
        display: block;
        margin: 0;
      }
      .invite-card-body {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 14px;
        display: flex;
        align-items: center;
        padding-left: 14px;
        .invite-card-info {
          flex: 1;
          font-size: 25px;
          color: #fff;
          padding-left: 24px;
          .invite-card-label {
            color: #fff;
            font-size: 46px;
            font-weight: bold;
          }
        }
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
    .invite-text {
      padding: 30px 0 60px;
      font-size: 25px;
    }
  }
  .invite-close {
    width: 53px;
    height: 53px;
    display: block;
    margin-top: 35px;
  }
}
</style>
